import { render, staticRenderFns } from "./ContactTypeDetail.vue?vue&type=template&id=f3040f2a&scoped=true&"
import script from "./ContactTypeDetail.vue?vue&type=script&lang=js&"
export * from "./ContactTypeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3040f2a",
  null
  
)

export default component.exports